import * as yup from 'yup';
import docs from './attachments';
import {
  acessoContraCheque,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoVeracidade,
} from './utils/rulesByKey';

export const PPMSchema = () => {
  const dadosSensiveis = consentimentoDadosSensiveis();

  return yup.object({
    ...acessoContraCheque,
    ...dadosSensiveis,
    ...declaracaoVeracidade,
    ...docs.PPMDocs.rules,
    ...aceiteInss,
  });
};

export const PPMInitialValues = {
  acessoContraCheque: '',
  consentimentoDadosSensiveis: false,
  aceiteInss: false,
  declaracaoVeracidade: false,
  ...docs.PPMDocs.initialValues,
};

export const PPMDocs = {
  ...docs.PPMDocs.docs,
};
